/* ===== FONTAH - Custom JS ===== */

var PERSONALIZABLES = [
  'mila', 'intense merlot', 'sevilla', 'rouge', 'mocha rich', 'siena',
  'iniciales butter yellow', 'angel rose', 'midnight navy', 'cupido',
  'cocoa mist', 'saint tropez', 'elara', 'vainilla blue', 'amelie',
  '1. nombre cursiva', 'baby blush', '1. iniciales 20', 'rose silk',
  'stella', 'sky bow', 'pink matcha', 'cotton sky', 'positano',
  'ivory', 'clean muse', 'baby deer'
];

document.addEventListener('DOMContentLoaded', function () {
  var h1 = document.querySelector('.product-info h1.product-title');
  if (!h1) return;

  var titulo = h1.textContent.trim().toLowerCase();
  var esPersonalizable = PERSONALIZABLES.some(function (nombre) {
    return titulo.includes(nombre);
  });

  var badges = document.createElement('div');
  badges.className = 'product-badges';

  var html = '<span class="product-badge">Doble protección</span>';
  html += '<span class="product-badge">Imán magnético interior</span>';
  if (esPersonalizable) {
    html += '<span class="product-badge">Personalizable</span>';
  }
  html += '<span class="product-badge">MagSafe compatible</span>';

  badges.innerHTML = html;
  h1.parentNode.insertBefore(badges, h1);
});
